import { makeAsyncActionCreators } from '../../helpers';
import { PackagesActionTypes } from '../types';

const fetchPackageByProjectId = makeAsyncActionCreators(
  PackagesActionTypes.fetchPackageByProjectId,
  ['projectId'],
  ['package'],
  ['error'],
);

const fetchPackageForProofByProjectId = makeAsyncActionCreators(
  PackagesActionTypes.fetchPackageForProofByProjectId,
  ['projectId'],
  ['package'],
  ['error'],
);

const fetchPackageByCustomerId = makeAsyncActionCreators(
  PackagesActionTypes.fetchPackageByCustomerId,
  ['userId'],
  ['package'],
  ['error'],
);

const getDataForUpgradesByProjectId = makeAsyncActionCreators(
  PackagesActionTypes.getDataForUpgradesByProjectId,
  ['projectId'],
  ['package', 'project'],
  ['error'],
);

const upgradePackageRequest = makeAsyncActionCreators(
  PackagesActionTypes.upgradePackageRequest,
  ['projectId', 'orders'],
  [],
  ['error'],
);

const revertUpgradeRequest = makeAsyncActionCreators(
  PackagesActionTypes.revertUpgradeRequest,
  ['projectId', 'upgradeRequestId'],
  [],
  ['error'],
);

const requestExtensionFeePayment = makeAsyncActionCreators(
  PackagesActionTypes.requestExtensionFeePayment,
  [],
  [],
  ['error'],
);

export default {
  fetchPackageForProofByProjectId,
  fetchPackageByCustomerId,
  fetchPackageByProjectId,
  getDataForUpgradesByProjectId,
  upgradePackageRequest,
  revertUpgradeRequest,
  requestExtensionFeePayment,
};
